<template>
  <div class="quiz_delay_bg_content">
    <div class="contain">
      <happy-scroll
        hide-horizontal
        resize
      >
        <div class="time_container">
          <van-row gutter="20">
            <van-col
              span="8"
              v-for="(item, index) in timedelay"
              :key="index"
            >
              <div
                class="circle click_able"
                :class="[chooseValue === index ? 'active' : '']"
                @click="choose(index)"
              >
                <div class="number">{{item > 60 ? item / 60 : item}}</div>
                <div class="danwei">{{item > 60 ? '分钟' : '秒'}}</div>
              </div>
            </van-col>
          </van-row>
          <van-row
            type="flex"
            justify="center"
          >
            <van-col span="8">
              <div
                class="button click_able"
                @click="confirm"
              >确定</div>
            </van-col>
          </van-row>
        </div>
      </happy-scroll>
      <van-image
        @click="$emit('closeDelay', false)"
        class="image click_able"
        width="100"
        height="100"
        fit="contain"
        src="/images/ico_close@2x.png"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image, Row, Col, Dialog } from 'vant'
Vue.use(Image).use(Row).use(Col).use(Dialog)
// @ is an alias to /src
export default {
  components: {
  },
  data () {
    return {
      timedelay: [30, 60, 120, 300, 600, 1200],
      chooseValue: -1
    }
  },
  methods: {
    confirm () {
      const _this = this
      if (this.chooseValue === -1) {
        Dialog.alert({
          title: '提示',
          message: '请先选择延迟时间'
        }).then(() => {
          // on close
        })
      } else {
        Dialog.confirm({
          title: '提示',
          message: _this.timedelay[_this.chooseValue] > 60 ? `确定要延迟${_this.timedelay[_this.chooseValue] / 60}分钟` : `确定要延迟${_this.timedelay[_this.chooseValue]}秒` + '吗？'
        }).then(() => {
          // on confirm
          _this.delay()
        }).catch(() => {
          // on cancel
        });
      }
    },
    delay () {
      this.$emit('delay', this.timedelay[this.chooseValue])
      this.$emit('closeDelay', false)
    },
    choose (index) {
      this.chooseValue = index
    }
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>
<style lang="less">
.quiz_delay_bg_content {
  height: 100%;
  padding: 50px 210px;
  border-radius: 48px;
  .contain {
    height: 100%;
    position: relative;
    padding: 130px 130px 0 130px;
    .happy-scroll-container {
      width: 100% !important;
      height: 100% !important;
    }
    .time_container {
      width: 100%;
      height: 100%;
      .circle {
        margin-top: 15px;
        width: 100%;
        height: 240px;
        background: rgba(255, 255, 255, 1);
        border-radius: 36px;
        border: 6px solid #68d5b5;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .number {
          color: #37ab7e;
          font-size: 100px;
          text-align: center;
          font-weight: bold;
        }
        .danwei {
          margin-top: 10px;
          font-size: 32px;
          color: #37ab7e;
          text-align: center;
        }
      }
      .active {
        border: 16px solid #37ab7e;
      }
      .button {
        width: 100%;
        height: 80px;
        background: rgba(255, 215, 35, 1);
        border-radius: 40px;
        color: rgba(6, 65, 52, 1);
        font-size: 32px;
        text-align: center;
        line-height: 80px;
        margin-top: 20px;
      }
    }
    .image {
      position: absolute;
      right: 40px;
      top: 10px;
    }
  }
}
</style>